import { Command } from './Command';
import { ChartEngine, ChartObject } from '../core/ChartEngine';

// --- 도형(SVG Object) 커맨드 ---
export class AddObjectCommand implements Command {
  constructor(private regionId: string, private layerId: string, private object: ChartObject) {}
  execute(engine: ChartEngine) { engine.addObjectToLayer(this.regionId, this.layerId, this.object); }
  undo(engine: ChartEngine) { engine.removeObjectFromLayer(this.regionId, this.layerId, this.object.id); }
}

export class RemoveObjectCommand implements Command {
  private savedObj: ChartObject | null = null;
  constructor(private regionId: string, private layerId: string, private objectId: string) {}
  execute(engine: ChartEngine) {
    const region = engine.getSnapshot().find(r => r.id === this.regionId);
    const layer = region?.layers.find(l => l.id === this.layerId);
    this.savedObj = layer?.objects?.find(o => o.id === this.objectId) || null;
    engine.removeObjectFromLayer(this.regionId, this.layerId, this.objectId);
  }
  undo(engine: ChartEngine) {
    if (this.savedObj) engine.addObjectToLayer(this.regionId, this.layerId, this.savedObj);
  }
}

